import React from 'react'
import PropTypes from 'prop-types'
import Portal from 'react-portal'
import classNames from 'classnames'

import Back from '../Back/Back'
import ScrollArea from '../ScrollArea/ScrollArea'

import styles from './InfoTip.css'

const ESC_KEY_CODE = 27
const HEADER_HEIGHT = 76
const CONTENT_BODY_PADDING = 55

class InfoTip extends React.Component {
    static propTypes = {
        children: PropTypes.node.isRequired,
        closeCaption: PropTypes.node,
        title: PropTypes.node,
        maxHeight: PropTypes.number,
        width: PropTypes.number,
        isOpened: PropTypes.bool.isRequired,
        onClose: PropTypes.func.isRequired,

        /**
         * This prop used for transfer background image
         *
         */
        classNameBg: PropTypes.string,

        /**
         * This prop used only for demonstration needs, so it is not needed in documentation
         *
         * @ignore
         */
        isDemo: PropTypes.bool,
    }

    static defaultProps = {
        maxHeight: 548,
        width: 600,
    }

    constructor(props) {
        super(props)

        const maxHeight = props.title ? props.maxHeight - CONTENT_BODY_PADDING - HEADER_HEIGHT : props.maxHeight - CONTENT_BODY_PADDING

        this.state = {
            isScrollEnabled: false,
            maxViewportHeight: maxHeight,
        }

        this.handleKeyDown = this.handleKeyDown.bind(this)
        this.handleOutsideClick = this.handleOutsideClick.bind(this)
    }

    componentWillMount() {
        window.addEventListener('keydown', this.handleKeyDown, true)
        window.addEventListener('click', this.handleOutsideClick, true)
    }

    componentWillUnmount() {
        window.removeEventListener('keydown', this.handleKeyDown, true)
        window.removeEventListener('click', this.handleOutsideClick, true)
    }

    componentDidMount() {
        const isScrollEnabled = this.isScrollEnabled()
        if (isScrollEnabled !== undefined && this.state.isScrollEnabled !== isScrollEnabled) {
            this.setState({ isScrollEnabled })
        }
    }

    componentDidUpdate() {
        const isScrollEnabled = this.isScrollEnabled()
        if (isScrollEnabled !== undefined && this.state.isScrollEnabled !== isScrollEnabled) {
            this.setState({ isScrollEnabled })
        }
    }

    handleKeyDown(e) {
        if (this.props.isOpened) {
            if (e.keyCode === ESC_KEY_CODE) {
                this.props.onClose()
                e.stopImmediatePropagation()
            }
        }
    }

    handleOutsideClick(e) {
        if (this.props.isOpened && !this._infotip.contains(e.target)) {
            this.props.onClose()
        }
    }

    isScrollEnabled() {
        if (!this._viewport || !this._content) return undefined

        const viewportHeight = this._viewport.getBoundingClientRect().height
        const contentHeight = this._content.getBoundingClientRect().height

        return contentHeight > viewportHeight
    }

    render() {
        const close = this.props.closeCaption ? (
            <div className={styles.close}>
                <Back
                    caption={this.props.closeCaption}
                    type="close"
                    side="right"
                    onClick={this.props.onClose}
                />
            </div>
        ) : null

        const bgElement = this.props.classNameBg ? (
            <div className={classNames(styles.bgElement, this.props.classNameBg)} />
        ) : null

        const header = this.props.title ? <div className={styles.header}>{this.props.title}</div> : null

        const classNameBase = classNames(styles.base, {
            [styles.isScrollEnabled]: this.state.isScrollEnabled,
            [styles.isOpened]: this.props.isOpened,
        })

        const infotip = (
            <div className={classNameBase}>
                <div className={styles.overlay} />
                <div
                    className={styles.infotip} ref={(c) => this._infotip = c}
                    style={{width: this.props.width, maxHeight: this.props.maxHeight}}
                >
                    {close}
                    {bgElement}
                    <div className={classNames(styles.inner)}>
                        {header}
                        <div className={styles.body}>
                            <div ref={(c) => this._viewport = c}>
                                <ScrollArea
                                    modifier="infotip"
                                    stepHeight={10}
                                    scrollableAreaHeight={this.state.maxViewportHeight}
                                >
                                    <div className={styles.content} ref={(c) => this._content = c}>
                                        {this.props.children}
                                    </div>
                                </ScrollArea>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )

        return this.props.isDemo ? infotip : <Portal isOpened>{infotip}</Portal>
    }
}

export default InfoTip



// WEBPACK FOOTER //
// ../node_modules/react-wot-bootstrap/lib/components/InfoTip/InfoTip.jsx